import { h } from '@stencil/core';

const KbbicoBadgeLogo = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" id="Layer_1" data-name="Layer 1" viewBox="0 0 399.21 144">
      <defs>
        <filter id="drop-shadow-1" filterUnits="userSpaceOnUse">
          <feOffset dx=".41" dy=".41" />
          <feGaussianBlur result="blur" stdDeviation=".41" />
          <feFlood flood-color="#221f1f" flood-opacity=".75" />
          <feComposite in2="blur" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter id="drop-shadow-2" filterUnits="userSpaceOnUse">
          <feOffset dx=".45" dy=".45" />
          <feGaussianBlur result="blur-2" stdDeviation=".45" />
          <feFlood flood-color="#221f1f" flood-opacity=".75" />
          <feComposite in2="blur-2" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter id="drop-shadow-3" filterUnits="userSpaceOnUse">
          <feOffset dx=".21" dy=".21" />
          <feGaussianBlur result="blur-3" stdDeviation=".12" />
          <feFlood flood-color="#221f1f" flood-opacity=".75" />
          <feComposite in2="blur-3" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
      </defs>
      <g>
        <path class="cls-3" style={{ fill: '#131f2c' }} d="m82.82,78.59v-25.91h6.37v25.91h-6.37Z" />
        <path
          class="cls-3"
          style={{ fill: '#131f2c' }}
          d="m103.89,78.59v-11.72c0-2.26-1.6-2.69-2.4-2.69s-2.4.44-2.4,2.69v11.72h-5.97v-19.58h5.82v1.6c1.2-1.2,2.98-1.82,4.55-1.82,1.86,0,3.35.62,4.4,1.67,1.67,1.67,1.96,3.53,1.96,5.6v12.52h-5.97Z"
        />
        <path
          class="cls-3"
          style={{ fill: '#131f2c' }}
          d="m120.35,78.81c-2.95,0-5.82-.15-8.52-2.84l3.86-3.86c1.64,1.64,3.75,1.64,4.77,1.64.87,0,2.55-.25,2.55-1.27,0-.55-.25-1.13-1.42-1.24l-3.02-.29c-3.38-.33-5.68-1.86-5.68-5.68,0-4.33,3.89-6.48,7.79-6.48,3.2,0,5.79.47,7.72,2.4l-3.68,3.68c-.98-.98-2.62-1.16-4.15-1.16s-1.93.69-1.93,1.13c0,.22-.07.95,1.27,1.09l3.02.29c4.11.4,5.9,2.84,5.9,5.97,0,4.62-3.93,6.62-8.48,6.62Z"
        />
        <path
          class="cls-3"
          style={{ fill: '#131f2c' }}
          d="m138.17,78.59c-4.33,0-6.08-3.09-6.08-5.79v-8.44h-1.78v-4.59h1.78v-5.6h5.97v5.6h3.09v4.59h-3.09v8.01c0,.76.4,1.2,1.2,1.2h1.89v5.02h-2.98Z"
        />
        <path
          class="cls-3"
          style={{ fill: '#131f2c' }}
          d="m153.86,78.59v-1.6c-1.2,1.2-2.29,1.78-4.37,1.78-1.97,0-3.6-.66-4.69-1.75s-1.71-2.77-1.71-4.59c0-2.95,2-5.68,6.66-5.68h3.97v-.51c0-1.78-.87-2.44-2.95-2.44-1.53,0-2.18.36-3.13,1.31l-3.71-3.71c2-2,3.82-2.62,7.13-2.62,5.6,0,8.62,2.33,8.62,7.1v12.7h-5.82Zm-.15-7.86h-3.02c-1.16,0-1.89.66-1.89,1.56s.65,1.64,1.96,1.64c1.16,0,1.71-.11,2.37-.73.44-.4.58-1.02.58-1.96v-.51Z"
        />
        <path
          class="cls-3"
          style={{ fill: '#131f2c' }}
          d="m173.91,78.59v-11.72c0-2.26-1.6-2.69-2.4-2.69s-2.4.44-2.4,2.69v11.72h-5.97v-19.58h5.82v1.6c1.2-1.2,2.98-1.82,4.55-1.82,1.86,0,3.35.62,4.4,1.67,1.67,1.67,1.96,3.53,1.96,5.6v12.52h-5.97Z"
        />
        <path
          class="cls-3"
          style={{ fill: '#131f2c' }}
          d="m189.95,78.59c-4.33,0-6.08-3.09-6.08-5.79v-8.44h-1.78v-4.59h1.78v-5.6h5.97v5.6h3.09v4.59h-3.09v8.01c0,.76.4,1.2,1.2,1.2h1.89v5.02h-2.98Z"
        />
        <path
          class="cls-3"
          style={{ fill: '#131f2c' }}
          d="m212.98,78.81c-3.02,0-5.31-1.02-7.21-2.91-2.73-2.73-2.62-6.37-2.62-10.26s-.11-7.53,2.62-10.26c1.89-1.89,4.19-2.91,7.21-2.91,4.91,0,8.88,2.73,9.83,8.44h-6.48c-.4-1.46-1.2-2.77-3.31-2.77-1.16,0-2.04.47-2.51,1.09-.58.76-.98,1.67-.98,6.41s.4,5.64.98,6.4c.47.62,1.35,1.09,2.51,1.09,2.11,0,2.91-1.31,3.31-2.77h6.48c-.95,5.71-4.91,8.44-9.83,8.44Z"
        />
        <path
          class="cls-3"
          style={{ fill: '#131f2c' }}
          d="m235.19,78.59v-1.6c-1.2,1.2-2.29,1.78-4.37,1.78-1.97,0-3.6-.66-4.69-1.75s-1.71-2.77-1.71-4.59c0-2.95,2-5.68,6.66-5.68h3.97v-.51c0-1.78-.87-2.44-2.95-2.44-1.53,0-2.18.36-3.13,1.31l-3.71-3.71c2-2,3.82-2.62,7.13-2.62,5.6,0,8.62,2.33,8.62,7.1v12.7h-5.82Zm-.15-7.86h-3.02c-1.16,0-1.89.66-1.89,1.56s.65,1.64,1.96,1.64c1.16,0,1.71-.11,2.37-.73.44-.4.58-1.02.58-1.96v-.51Z"
        />
        <path
          class="cls-3"
          style={{ fill: '#131f2c' }}
          d="m251.43,78.81c-2.95,0-5.82-.15-8.52-2.84l3.86-3.86c1.64,1.64,3.75,1.64,4.77,1.64.87,0,2.55-.25,2.55-1.27,0-.55-.25-1.13-1.42-1.24l-3.02-.29c-3.38-.33-5.68-1.86-5.68-5.68,0-4.33,3.89-6.48,7.79-6.48,3.2,0,5.79.47,7.72,2.4l-3.68,3.68c-.98-.98-2.62-1.16-4.15-1.16s-1.93.69-1.93,1.13c0,.22-.07.95,1.27,1.09l3.02.29c4.11.4,5.9,2.84,5.9,5.97,0,4.62-3.93,6.62-8.48,6.62Z"
        />
        <path
          class="cls-3"
          style={{ fill: '#131f2c' }}
          d="m272.94,78.59v-11.86c0-2.11-1.53-2.55-2.29-2.55s-2.29.44-2.29,2.55v11.86h-5.97v-25.91h5.97v7.93c1.24-1.24,2.8-1.82,4.29-1.82,4.22,0,6.26,3.13,6.26,7.1v12.7h-5.97Z"
        />
        <path
          class="cls-3"
          style={{ fill: '#131f2c' }}
          d="m306.86,75.9c-1.89,1.89-4.08,2.91-7.24,2.91s-5.35-1.02-7.24-2.91c-2.73-2.73-2.62-6.37-2.62-10.26s-.11-7.53,2.62-10.26c1.89-1.89,4.08-2.91,7.24-2.91s5.35,1.02,7.24,2.91c2.73,2.73,2.62,6.37,2.62,10.26s.11,7.53-2.62,10.26Zm-4.69-16.63c-.47-.62-1.38-1.13-2.55-1.13s-2.07.51-2.55,1.13c-.58.76-.95,1.64-.95,6.37s.36,5.57.95,6.33c.47.62,1.38,1.16,2.55,1.16s2.07-.55,2.55-1.16c.58-.76.95-1.6.95-6.33s-.36-5.6-.95-6.37Z"
        />
        <path
          class="cls-3"
          style={{ fill: '#131f2c' }}
          d="m319.46,64.37v14.23h-5.97v-14.23h-1.78v-4.59h1.78v-1.71c0-2.69,1.75-5.79,6.08-5.79h3.17v5.02h-2.07c-.8,0-1.2.44-1.2,1.2v1.27h3.28v4.59h-3.28Z"
        />
        <path
          class="cls-3"
          style={{ fill: '#131f2c' }}
          d="m332.23,64.37v14.23h-5.97v-14.23h-1.78v-4.59h1.78v-1.71c0-2.69,1.75-5.79,6.08-5.79h3.17v5.02h-2.07c-.8,0-1.2.44-1.2,1.2v1.27h3.28v4.59h-3.28Z"
        />
        <path
          class="cls-3"
          style={{ fill: '#131f2c' }}
          d="m342.97,70.73c0,1.6,1.24,3.06,3.46,3.06,2.07,0,2.98-.58,4.04-1.64l3.57,3.57c-2,2-3.97,3.09-7.61,3.09-4.33,0-9.32-1.56-9.32-10.01,0-6.4,3.64-10.01,8.77-10.01,5.68,0,8.81,4.15,8.81,9.28v2.66h-11.72Zm5.5-5.5c-.36-.84-1.16-1.53-2.58-1.53s-2.22.69-2.58,1.53c-.25.51-.33,1.06-.33,1.53h5.82c0-.47-.07-1.02-.33-1.53Z"
        />
        <path
          class="cls-3"
          style={{ fill: '#131f2c' }}
          d="m368,65.2c-.58-.58-1.13-1.02-2.15-1.02-.8,0-2.4.47-2.4,2.69v11.72h-5.97v-19.58h5.82v1.6c.87-.87,2.58-1.82,4.62-1.82,1.93,0,3.24.47,4.59,1.82l-4.51,4.58Z"
        />
      </g>
      <g>
        <path
          class="cls-4"
          style={{ fill: '#1d3e74' }}
          d="m60.91,119.45c-1.07,0-1.94-.87-1.94-1.94s.87-1.94,1.94-1.94,1.94.87,1.94,1.94-.87,1.94-1.94,1.94Zm0-3.59c-.9,0-1.63.74-1.63,1.65s.73,1.65,1.63,1.65,1.63-.74,1.63-1.65-.73-1.65-1.63-1.65Zm.47,2.71l-.49-.87h-.32v.87h-.29v-2.12h.72c.37,0,.67.28.67.64,0,.31-.19.5-.45.58l.51.9h-.34Zm-.41-1.86h-.4v.74h.4c.24,0,.4-.16.4-.37s-.17-.37-.4-.37Z"
        />
        <g>
          <g>
            <polygon
              class="cls-4"
              style={{ fill: '#1d3e74' }}
              points="25.75 36.07 30.14 39.13 32.09 34.14 35.8 38.01 38.69 33.5 41.57 38.01 45.28 34.15 47.23 39.13 51.63 36.07 52.56 41.34 55.83 39.91 55.83 26.19 21.5 26.19 21.5 39.89 24.81 41.33 25.75 36.07"
            />
            <polygon
              class="cls-4"
              style={{ fill: '#1d3e74' }}
              points="51.61 98.54 47.22 95.48 45.27 100.47 41.56 96.61 38.67 101.11 35.79 96.6 32.08 100.46 30.13 95.48 25.73 98.54 24.79 93.27 21.5 94.71 21.5 115.9 38.68 102.71 55.86 115.9 55.86 94.72 52.55 93.27 51.61 98.54"
            />
            <path
              class="cls-1"
              style={{ fill: '#f3bc2a' }}
              d="m67.98,70.2l4.51-2.88-4.51-2.89,3.86-3.71-4.99-1.95,3.06-4.39-5.27-.94,2.15-4.9-5.35.11,1.15-5.23-5.12,1.12v-19.98H19.86v19.96s-5.08-1.12-5.08-1.12l1.15,5.23-5.35-.11,2.15,4.9-5.27.94,3.06,4.39-4.99,1.95,3.86,3.71-4.51,2.88,4.51,2.89-3.86,3.71,4.98,1.95-3.06,4.39,5.27.94-2.15,4.9,5.35-.1-1.15,5.23,5.09-1.12v29.14s18.83-14.45,18.83-14.45l18.82,14.45v-29.13l5.08,1.12-1.15-5.23,5.35.11-2.15-4.9,5.27-.94-3.06-4.39,4.99-1.95-3.86-3.71ZM21.5,26.19h34.33v13.72l-3.27,1.43-.94-5.27-4.39,3.06-1.95-4.99-3.71,3.86-2.88-4.51-2.89,4.51-3.71-3.86-1.95,4.99-4.39-3.06-.94,5.27-3.31-1.45v-13.7Zm34.36,89.71l-17.18-13.19-17.19,13.19v-21.19l3.3-1.44.94,5.27,4.39-3.06,1.95,4.99,3.71-3.86,2.89,4.51,2.89-4.51,3.71,3.86,1.95-4.99,4.39,3.06.94-5.27,3.31,1.45v21.18Z"
            />
          </g>
          <path
            class="cls-4"
            style={{ fill: '#1d3e74' }}
            d="m38.67,39.22c-15.53,0-28.12,12.6-28.12,28.12,0,15.51,12.58,28.09,28.12,28.09,15.53,0,28.14-12.57,28.14-28.09,0-15.52-12.61-28.12-28.14-28.12Z"
          />
          <path class="cls-2" style={{ fill: '#fff' }} d="m55.62,56.39l-2.71,1.89-.9-1.28,2.71-1.89,2.51-4.71.98,1.4-1.8,3.09,3.52-.65.98,1.4-5.3.74Z" />
          <path
            class="cls-2"
            style={{ fill: '#fff' }}
            d="m46.97,52.43l4.89-6.41,4.23,3.21-.85,1.12-2.98-2.26-1.15,1.5,2.54,1.92-.85,1.12-2.54-1.92-1.19,1.56,2.98,2.26-.85,1.12-4.23-3.21Z"
          />
          <path class="cls-2" style={{ fill: '#fff' }} d="m41.3,50.51l2.16-7.76,1.52.42-1.79,6.41,3.53.98-.38,1.35-5.05-1.4Z" />
          <path class="cls-2" style={{ fill: '#fff' }} d="m35.21,50.69l-.73-8.02,1.57-.14.6,6.62,3.65-.33.13,1.4-5.22.47Z" />
          <path
            class="cls-2"
            style={{ fill: '#fff' }}
            d="m29.31,53.06l-3.37-7.32,4.84-2.21.59,1.27-3.4,1.55.79,1.72,2.9-1.32.59,1.27-2.9,1.32.82,1.78,3.4-1.55.59,1.27-4.84,2.21Z"
          />
          <g class="cls-7" style={{ filter: 'url(#drop-shadow-1)' }}>
            <path
              class="cls-2"
              style={{ fill: '#fff' }}
              d="m27.46,54.79l-4.13-.88.24,1.6,1.82,1.6-1.04,1.18-6.05-5.33,1.05-1.18,2.63,2.32-.75-4.45,1.27-1.43.63,4.12,5.55,1.07-1.22,1.37Z"
            />
          </g>
          <path
            class="cls-2"
            style={{ fill: '#fff' }}
            d="m62.3,71.79l-1.92-4.05-.96,1.37v2.67h-1.45v-8.89h1.45v3.87s2.63-3.87,2.63-3.87h1.77s-2.47,3.53-2.47,3.53l2.65,5.36h-1.7Z"
          />
          <path
            class="cls-2"
            style={{ fill: '#fff' }}
            d="m56.27,70.89c-.52.62-1.16.97-2.01.97s-1.5-.35-2.02-.97c-.75-.9-.73-2.01-.73-3.55,0-1.54-.02-2.65.73-3.55.52-.62,1.17-.97,2.02-.97s1.49.35,2.01.97c.75.9.74,2.01.74,3.55,0,1.54.01,2.65-.74,3.55Zm-1.08-6.04c-.21-.29-.53-.47-.93-.47s-.73.19-.94.47c-.28.37-.36.79-.36,2.5,0,1.71.07,2.12.36,2.5.21.29.54.48.94.48s.72-.19.93-.48c.28-.38.37-.79.37-2.5s-.08-2.12-.37-2.5Z"
          />
          <path
            class="cls-2"
            style={{ fill: '#fff' }}
            d="m50.06,70.89c-.52.62-1.16.97-2.01.97s-1.5-.35-2.02-.97c-.75-.9-.73-2.01-.73-3.55,0-1.54-.02-2.65.73-3.55.52-.62,1.17-.97,2.02-.97s1.49.35,2.01.97c.75.9.74,2.01.74,3.55,0,1.54.01,2.65-.74,3.55Zm-1.08-6.04c-.21-.29-.53-.47-.93-.47s-.73.19-.94.47c-.28.37-.36.79-.36,2.5s.07,2.12.36,2.5c.21.29.54.48.94.48s.72-.19.93-.48c.28-.38.37-.79.37-2.5s-.08-2.12-.37-2.5Z"
          />
          <path
            class="cls-2"
            style={{ fill: '#fff' }}
            d="m42.32,71.79h-3.12v-8.89h2.99c1.46,0,2.3.97,2.3,2.5,0,.99-.54,1.62-.92,1.84.45.25,1.03.81,1.03,2,0,1.66-.95,2.56-2.28,2.56Zm-.24-7.34h-1.42s0,2.05,0,2.05h1.42c.62,0,.96-.41.96-1.02s-.35-1.02-.96-1.02Zm.09,3.61h-1.52s0,2.19,0,2.19h1.52c.66,0,.97-.5.97-1.1s-.31-1.09-.97-1.09Z"
          />
          <path class="cls-2" style={{ fill: '#fff' }} d="m31.5,71.79v-8.89h4.91v1.55h-3.45s0,2.09,0,2.09h2.94v1.55h-2.94s0,2.16,0,2.16h3.45v1.55h-4.91Z" />
          <path
            class="cls-2"
            style={{ fill: '#fff' }}
            d="m27.67,71.86c-1.53,0-2.74-1.24-2.74-3.12v-5.84h1.46v5.78c0,1.02.5,1.64,1.29,1.64s1.3-.61,1.3-1.64v-5.78h1.44v5.84c0,1.89-1.21,3.12-2.74,3.12Z"
          />
          <path class="cls-2" style={{ fill: '#fff' }} d="m19.68,71.79v-8.89h1.46v7.34s3.38,0,3.38,0v1.55h-4.84Z" />
          <g class="cls-5" style={{ filter: 'url(#drop-shadow-2)' }}>
            <path
              class="cls-2"
              style={{ fill: '#fff' }}
              d="m16.45,71.79h-3.12v-8.89h2.99c1.46,0,2.3.97,2.3,2.5,0,.99-.54,1.62-.92,1.84.45.25,1.03.81,1.03,2,0,1.66-.95,2.56-2.28,2.56Zm-.24-7.34h-1.42s0,2.05,0,2.05h1.42c.62,0,.96-.41.96-1.02s-.35-1.02-.96-1.02Zm.09,3.61h-1.52s0,2.19,0,2.19h1.52c.66,0,.97-.5.97-1.1s-.31-1.09-.97-1.09Z"
            />
          </g>
          <g>
            <path
              class="cls-2"
              style={{ fill: '#fff' }}
              d="m19.91,80.26c-.45-.08-.83-.3-1.12-.73-.3-.44-.37-.88-.28-1.34.13-.66.62-.99,1.28-1.46.67-.47,1.14-.82,1.8-.71.45.08.83.3,1.13.74.29.44.37.87.28,1.33-.13.66-.61,1-1.28,1.46-.67.47-1.15.82-1.8.7Zm2.25-2.4c.05-.2.02-.42-.12-.62-.14-.21-.34-.32-.54-.34-.26-.03-.47.06-1.21.58-.74.52-.9.69-.96.95-.05.2-.02.43.12.63.14.2.33.31.53.33.26.03.47-.05,1.21-.58.74-.52.89-.69.96-.95Z"
            />
            <path class="cls-2" style={{ fill: '#fff' }} d="m23.92,79.93l-.83.81,1.24,1.33-.59.57-1.24-1.33-1.38,1.34-.62-.66,3.39-3.31,2.07,2.22-.59.58-1.46-1.56Z" />
            <path class="cls-2" style={{ fill: '#fff' }} d="m26.71,82.58l-.68.95,1.45,1.08-.48.67-1.45-1.08-1.12,1.57-.72-.54,2.77-3.87,2.43,1.81-.48.67-1.71-1.27Z" />
            <path class="cls-2" style={{ fill: '#fff' }} d="m27.31,87.67l2.15-4.25.79.42-2.16,4.25-.79-.42Z" />
            <path
              class="cls-2"
              style={{ fill: '#fff' }}
              d="m30.64,89.2c-.47-.18-.79-.5-.98-.92-.27-.62-.06-1.17.22-1.95.28-.78.47-1.34,1.06-1.64.41-.2.86-.24,1.33-.06.8.3,1.25,1.01,1.07,2.01l-.85-.31c.05-.39-.07-.75-.49-.91-.23-.09-.45-.07-.62.03-.23.13-.36.33-.67,1.19-.31.86-.34,1.1-.24,1.35.07.19.22.35.45.43.42.16.74-.04.95-.37l.85.32c-.49.88-1.29,1.13-2.09.83Z"
            />
            <path class="cls-2" style={{ fill: '#fff' }} d="m33.27,90l.97-4.69.87.19-.96,4.69-.87-.19Z" />
            <path class="cls-2" style={{ fill: '#fff' }} d="m37.77,90.63l-.2-.87-1.62-.13-.34.82-.92-.08,2.03-4.63.7.06,1.28,4.91-.93-.08Zm-.79-3.45l-.71,1.69,1.13.09-.42-1.78Z" />
            <path class="cls-2" style={{ fill: '#fff' }} d="m39.29,90.63l-.27-4.78.89-.05.22,3.94,2.07-.12.05.83-2.96.18Z" />
            <path
              class="cls-2"
              style={{ fill: '#fff' }}
              d="m46.82,88.54c-.21.5-.57.79-1.03.96-.47.17-.92.14-1.33-.07-.59-.3-.78-.86-1.06-1.64-.28-.78-.49-1.34-.22-1.95.19-.43.5-.74.98-.92.99-.37,1.74.13,2.13.85l-.84.31c-.25-.39-.58-.53-1.01-.37-.23.08-.38.25-.45.44-.1.25-.06.47.24,1.34.31.87.42,1.07.66,1.2.17.1.39.12.62.04.25-.09.42-.26.51-.47.08-.22.06-.44-.02-.67l-.06-.17-.79.29-.26-.73,1.62-.6.23.66c.23.65.26,1.08.08,1.52Z"
            />
            <path
              class="cls-2"
              style={{ fill: '#fff' }}
              d="m49.98,87.71c-.82.46-1.78.25-2.27-.63l-1.5-2.75.78-.44,1.49,2.72c.26.48.69.62,1.11.38.42-.24.54-.68.27-1.16l-1.49-2.72.77-.44,1.5,2.75c.49.89.15,1.84-.66,2.3Z"
            />
            <path class="cls-2" style={{ fill: '#fff' }} d="m52.64,86l-2.96-3.71.69-.57,2.96,3.71-.69.57Z" />
            <path
              class="cls-2"
              style={{ fill: '#fff' }}
              d="m55.96,82.36c0,.44-.2.85-.54,1.19l-1.17,1.18-3.3-3.41,1.17-1.18c.34-.34.74-.55,1.17-.54.74.02,1.15.52,1.65,1.03.49.51,1.01.97,1.02,1.72Zm-2.65-1.83c-.24-.03-.46.05-.68.27l-.48.48,2.15,2.22.48-.48c.22-.22.3-.44.27-.69-.03-.27-.25-.54-.75-1.05-.5-.52-.73-.71-1-.75Z"
            />
            <path class="cls-2" style={{ fill: '#fff' }} d="m57.24,81.37l-3.91-2.65,1.67-2.55.68.46-1.17,1.8.91.62,1-1.53.68.46-1,1.53.95.65,1.17-1.8.68.46-1.67,2.56Z" />
          </g>
          <g class="cls-6" style={{ filter: 'url(#drop-shadow-3)' }}>
            <path class="cls-1" d="m38.6,53.78c5.54,0,10.3,3.35,12.37,8.13h.83c-2.12-5.22-7.23-8.9-13.2-8.9-5.98,0-11.08,3.68-13.2,8.9h.83c2.08-4.78,6.83-8.13,12.37-8.13Z" />
            <path class="cls-1" d="m38.6,80.78c-5.5,0-10.23-3.3-12.33-8.02h-.83c2.15,5.16,7.23,8.79,13.16,8.79,5.94,0,11.02-3.63,13.16-8.79h-.83c-2.1,4.72-6.83,8.02-12.33,8.02Z" />
          </g>
        </g>
      </g>
    </svg>
  );
};

export default KbbicoBadgeLogo;
